module.exports = __webpack_public_path__ + "static/media/3DPPA15.055c3f74.jpg";